import React from "react";
import BreakLine from "../../../component/Desktop/breakLine";
import RowInput from "../../../component/Desktop/rowInput";
import FormInput from "../../../component/FormInput";
import { INPUT_TYPE, lang, MODE_SCREEN } from "../../../constants/common.const";
import { Descriptions, Tooltip } from "antd";
import { isEmptyData } from "../../../utils/helper";
import { QuestionCircleOutlined } from "@ant-design/icons";
const ViewFacilityMaster = ({
  mode = MODE_SCREEN.VIEW,
  facilityData,
  setFacilityData,
  inputRefs,
  optionArea,
  optionPlant,
  setIsFillData,
}) => {
  const handleChangeData =
    (key, type = INPUT_TYPE.INPUT, rule) =>
    (e) => {
      const value = type === INPUT_TYPE.SELECT ? e : e.target.value;
      if (rule && Array.isArray(rule) && rule.length > 0) {
        const isValid = rule.some((r) => r.test(value));
        if (!isValid) {
          return;
        }
      }
      if (String(value).length > 255) {
        return;
      }

      const newData = {
        ...facilityData,
        [key]: {
          ...facilityData[key],
          value,
        },
      };
      if (key === "facilityNumber") {
        if (Number(value) >= 50) {
          newData.processingAreaName.value = "";
        }
      }
      setFacilityData(newData);
      setIsFillData(true);
    };

  const listFacilityMasterField = [
    {
      title: lang.FACILITY_ID,
      value: facilityData.id,
      type: INPUT_TYPE.INPUT,
      rule: [/^\d*$/],
      reqrired: true,
      key: "id",
      disabled: mode === MODE_SCREEN.EDIT || mode === MODE_SCREEN.ADD,
    },
    {
      title: lang.FACILITY_MASTER_NAME,
      value: facilityData.facilityName,
      type: INPUT_TYPE.INPUT,
      rule: [],
      reqrired: true,
      key: "facilityName",
    },
    {
      title: lang.AREA_NAME_FACILITY,
      value: { ...facilityData.processingAreaName, options: optionArea },
      type: INPUT_TYPE.SELECT,
      rule: [],
      key: "processingAreaName",
      reqrired:
        isEmptyData(facilityData.facilityNumber.value) ||
        Number(facilityData.facilityNumber.value) < 50,
      disabled: Number(facilityData.facilityNumber.value) >= 50,
    },
    {
      title: lang.MODEL_CODE,
      value: { ...facilityData.plantCode, options: optionPlant },
      type: INPUT_TYPE.SELECT,
      rule: [],
      key: "plantCode",
      reqrired: true,
      disabled: true,
    },
    {
      title:<>{ lang.FACILITY_NUMBER} <Tooltip title="施設がその他の場合、施設番号を50以上を設定してください。"><QuestionCircleOutlined style={{
        cursor:"pointer"
      }}  /></Tooltip></>,
      value: facilityData.facilityNumber,
      type: INPUT_TYPE.INPUT,
      rule: [/^(\d{1,2})?$/],
      key: "facilityNumber",
      reqrired: true,
      disabled: mode === MODE_SCREEN.EDIT,
      onBlur: (e) => {
        const value = String(e.target.value).trim();
        if (
          !isNaN(value) &&
          Number(value) < 10 &&
          !isEmptyData(value)
        ) {
          const newData = {
            ...facilityData,
            facilityNumber: {
              ...facilityData["facilityNumber"],
              value: "0" + Number(value),
            },
          };
          setFacilityData(newData);
          setIsFillData(true);
        }
      },
    },
    {
      title: lang.DISPLAY_ORDER,
      value: facilityData.display,
      type: INPUT_TYPE.INPUT,
      rule: [/^\d*$/],
      key: "display",
      disabled: true,
    },
  ];

  const renderDataFacility = listFacilityMasterField.map((fa, index) => {
    return (
      <Descriptions.Item
        labelStyle={{
          width: "30%",
          fontWeight: "bold",
          display: fa.hideTitle && "none",
        }}
        contentStyle={{ padding: "4px 4px", width: 70 }}
        key={index}
        label={
          <div
            style={{
              cursor:
                fa.required && mode !== MODE_SCREEN.VIEW
                  ? "pointer"
                  : "default",
              fontWeight: "bold",
            }}
            className="labelInputEquipment"
          >
            <span
              style={{
                color: fa.reqrired ? "#ff2255" : "",
              }}
            >
              {fa.title}
            </span>
          </div>
        }
        span={fa.span || 5}
      >
        {mode === MODE_SCREEN.VIEW ? (
          String(fa.value.valueShow || "") || fa.value.value
        ) : (
          <FormInput
            haveEmptyOption={false}
            refer={(el) => (inputRefs.current[fa.key] = el)}
            onChange={handleChangeData(fa.key, fa.type, fa.rule)}
            valueObject={fa.value}
            onBlur={fa.onBlur}
            {...fa}
          />
        )}
      </Descriptions.Item>
    );
  });

  return (
    <div>
      {" "}
      <Descriptions
        className="customEquipmentDes"
        size="small"
        column={5}
        bordered
      >
        {renderDataFacility}
      </Descriptions>
    </div>
  );
};

export default ViewFacilityMaster;
